var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSermonPause(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.4108 56.7698L85.1788 45.0008L73.4108 33.2318V16.5898H56.7688L45.0008 4.8208L33.2328 16.5898H16.5898V33.2328L4.82178 45.0008L16.5898 56.7698V73.4128H33.2328L45.0008 85.1778L56.7688 73.4088H73.4108V56.7698Z",
    fill: "url(#paint0_radial_25_1427)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0039 87.6642V90.0012L31.8149 76.8112L32.4999 75.1582L45.0039 87.6642Z",
    fill: "#341C00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1591 75.1592L76.8121 76.8122H58.1601L57.4751 75.1592H75.1591Z",
    fill: "#472900"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5319 75.1592L31.8469 76.8122H13.1909L14.8439 75.1592H32.5319Z",
    fill: "#472900"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4991 75.1592L58.1841 76.8122L44.9941 90.0022V87.6652L57.4991 75.1592Z",
    fill: "#7C4A00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9941 87.207V84.8701L56.6781 73.186L57.3621 74.8391L44.9941 87.207Z",
    fill: "#6E4100"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6362 74.8391L33.3212 73.186L45.0052 84.8701V87.207L32.6362 74.8391Z",
    fill: "#F28D09"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1548 74.8391L16.8078 73.186H33.3328L32.6478 74.8391H15.1548Z",
    fill: "#BD7007"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M57.353 74.8391L56.6689 73.186H73.1939L74.8469 74.8391H57.353Z",
    fill: "#BD7007"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8429 75.159L13.1899 76.812V58.164L14.8429 57.479V75.159Z",
    fill: "#402400"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1592 57.478L76.8122 58.163V76.811L75.1592 75.158V57.478Z",
    fill: "#CE7908"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8351 74.8499L73.1821 73.1969V56.6689L74.8351 57.3539V74.8499Z",
    fill: "#402400"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.167 57.353L16.82 56.668V73.197L15.167 74.85V57.353Z",
    fill: "#CE7908"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M2.79883 44.9971H5.13583L16.8198 56.6811L15.1668 57.3661L2.79883 44.9971Z",
    fill: "#F28D09"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6642 44.9961H90.0012L76.8112 58.1861L75.1582 57.5011L87.6642 44.9961Z",
    fill: "#7C4A00"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M14.843 57.5011L13.19 58.1861L0 44.9961H2.337L14.843 57.5011Z",
    fill: "#341C00"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8351 57.3651L73.1821 56.6801L84.8661 44.9961H87.2031L74.8351 57.3651Z",
    fill: "#6E4100"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1668 32.6372L16.8198 33.3222L5.13583 45.0052H2.79883L15.1668 32.6372Z",
    fill: "#7C4A00"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2031 45.0052H84.8661L73.1821 33.3222L74.8351 32.6372L87.2031 45.0052Z",
    fill: "#341C00"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1592 32.4999L76.8122 31.8149L90.0022 45.0049H87.6652L75.1592 32.4999Z",
    fill: "#F28D09"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M2.33798 45.0049H0.000976562L13.191 31.8149L14.844 32.4999L2.33798 45.0049Z",
    fill: "#6E4100"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6482 15.1631L33.3332 16.8161H16.8122L15.1592 15.1631H32.6482Z",
    fill: "#472900"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M15.167 15.1519L16.82 16.8049V33.3339L15.167 32.6489V15.1519Z",
    fill: "#CE7908"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M74.847 15.1631L73.194 16.8161H56.665L57.349 15.1631H74.847Z",
    fill: "#472900"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8351 32.6489L73.1821 33.3339V16.8049L74.8351 15.1519V32.6489Z",
    fill: "#402400"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4751 14.8439L58.1601 13.1909H76.8121L75.1591 14.8439H57.4751Z",
    fill: "#BD7007"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8429 14.8439L13.1909 13.1899H31.8429L32.5279 14.8429L14.8429 14.8439Z",
    fill: "#BD7007"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8429 32.5239L13.1899 31.8389V13.1899L14.8429 14.8429V32.5239Z",
    fill: "#402400"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1592 14.8439L76.8122 13.1909V31.8389L75.1592 32.5239V14.8439Z",
    fill: "#CE7908"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3661 15.1629L56.6821 16.8159L44.9951 5.13192V2.79492L57.3661 15.1629Z",
    fill: "#341C00"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0038 2.79492V5.13192L33.3198 16.8159L32.6348 15.1629L45.0038 2.79492Z",
    fill: "#7C4A00"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5019 14.843L31.8169 13.19L45.0029 0V2.337L32.5019 14.843Z",
    fill: "#6E4100"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M75.167 32.503L87.667 45.003L75.167 57.503V75.172H57.495L44.995 87.672L32.502 75.172H14.834V57.498L2.33398 44.998L14.834 32.498V14.835H32.506L44.999 2.33496L57.499 14.835H75.167V32.503ZM74.845 57.361L87.205 45.001L74.845 32.64V15.155H57.362L44.998 2.79496L32.639 15.155H15.158V32.641L2.79799 45.003L15.158 57.363V74.849H32.639L44.998 87.203L57.361 74.843H74.845V57.361Z",
    fill: "#B56B06"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9941 2.33797V0.000976562L58.1841 13.191L57.4991 14.844L44.9941 2.33797Z",
    fill: "#F28D09"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M45.001 62.001C54.3898 62.001 62.001 54.3898 62.001 45.001C62.001 35.6121 54.3898 28.001 45.001 28.001C35.6121 28.001 28.001 35.6121 28.001 45.001C28.001 54.3898 35.6121 62.001 45.001 62.001Z",
    fill: "#378E55"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M43.001 39.501C43.001 38.6725 42.3294 38.001 41.501 38.001C40.6725 38.001 40.001 38.6725 40.001 39.501V50.501C40.001 51.3294 40.6725 52.001 41.501 52.001C42.3294 52.001 43.001 51.3294 43.001 50.501V39.501Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M50.001 39.501C50.001 38.6725 49.3294 38.001 48.501 38.001C47.6725 38.001 47.001 38.6725 47.001 39.501V50.501C47.001 51.3294 47.6725 52.001 48.501 52.001C49.3294 52.001 50.001 51.3294 50.001 50.501V39.501Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_25_1427",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.0003 44.9993) scale(40.1785 40.1785)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9E4BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4A226"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSermonPause);
export default __webpack_public_path__ + "static/media/sermon-pause.3472ac4707a465a1b6173a54f887597b.svg";
export { ForwardRef as ReactComponent };